import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";

export default class RetiradaStore {

    @observable armadores;
    armadorSelecionado;
    @observable operacoes;
    operacaoSelecionado;
    @observable tiposCntr;
    tipoCntrSelecionado;
    @observable shipments;

    @observable containers;

    @observable container;

    constructor() {
        this.container = [];
        this.containers = false;
        this.armadores = [];
        this.armadorSelecionado = [];
        this.operacoes = [];
        this.operacaoSelecionado = [];
        this.tiposCntr = [];
        this.tipoCntrSelecionado = [];
        
        this.shipments = [];
        
        this.tiposCntrVisible = [];
        this.shipmentsVisible = [];

        this.atualizaDados = true;
        this.adicionaNovoItemRetirada();
        this.bloqueia();
        this.service = new AgendamentoContainerService();
    };

    adicionaNovoItemRetirada = () => {
        this.armadores.push([]);
        this.armadorSelecionado.push([]);
        
        this.operacoes.push([]);
        this.operacaoSelecionado.push([]);
        
        this.tiposCntr.push([]);
        this.tipoCntrSelecionado.push([]);
        
        this.shipments.push([]);   

        this.tiposCntrVisible.push(false);
        this.shipmentsVisible.push(false);

        this.container.push([]);   
    };

    removerItemRetirada = (index) => {
        this.armadores.splice(index, 1);
        this.operacoes.splice(index, 1);
        this.tiposCntr.splice(index, 1);
        
        this.armadorSelecionado.splice(index, 1);
        this.operacaoSelecionado.splice(index, 1);
        this.tipoCntrSelecionado.splice(index, 1);

        this.tiposCntrVisible.splice(index, 1);
        this.shipmentsVisible.splice(index, 1);

        this.container.splice(index, 1);
    };
    
    bloqueia = (index = 0) => {
        this.armadores[index] = [];
        this.operacoes[index] = [];
        this.tiposCntr[index] = [];
        this.shipments[index] = [];
        this.container[index] = [];
        
        this.tiposCntrVisible[index] = false;
        this.shipmentsVisible[index] = false;
    };

    carregarComboboxesBarcaca = (dadosDoAgendamento, agendTipoId, agendId) => {
        let lista = _.get(dadosDoAgendamento, "listaBookings[0].containers");

        lista.map((cntr, x) => {
            this.carregarArmadores(agendTipoId, x);

            let armador = {
                            value:_.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Armador.Id`), 
                            label: _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Armador.Nome`)
                        }  
            this.armadorSelecionado[x] = armador;

            this.dadosBoxOperacoes(_.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Armador.Nome`), agendTipoId, x);
            
            let operacao = {
                            value:_.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Operacao.Id`), 
                            label: _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Operacao.Nome`)
                        }  
            this.operacaoSelecionado[x] = operacao;

            this.dadosBoxTiposCntr(_.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Armador.Nome`)
                                    , _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Operacao.Nome`), x);

            let tipoCntr = {
                            value:_.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Tipo.Id`), 
                            label: _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Tipo.Nome`)
                        }  
            this.tipoCntrSelecionado[x] = tipoCntr;

            this.dadosBoxShipment(_.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Armador.Nome`)
                                    , _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Operacao.Nome`)
                                    , _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Tipo.Nome`), x);
                                    
            this.dadosCampoContainer(_.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Armador.Id`)
                                    , _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Operacao.Nome`)
                                    , _.get(dadosDoAgendamento, `listaBookings[0].containers[${x}].Tipo.Nome`)
                                    , agendId, x);
        });
    };

    carregarComboboxesDocumentos = (dadosDoAgendamento) => {
        this.containers = [];
        let lista = _.get(dadosDoAgendamento, "listaBookings");
        lista.map(cntr => {
            this.containers.push({ Container: _.get(cntr, "containers[0].CodCntr") });
        });
    };

    carregarArmadores = (agendTipoId, index = 0) => {
        this.bloqueia(index);
        this.service.listarArmadoresVazio(agendTipoId).then(response => {
            this.armadores[index] = response.data;
        }).catch( erro => {
            console.log(erro)
        });
    };

    carregarOperacoes = (armador, agendTipoId, index = 0) => {
        this.operacoes[index] = [];
        this.tiposCntr[index] = [];
        this.shipments[index] = [];
        
        this.tiposCntrVisible[index] = false;
        this.shipmentsVisible[index] = false;

        if (armador) this.dadosBoxOperacoes(armador.label, agendTipoId, index);
    };

    dadosBoxOperacoes = (armador, agendTipoId, index) => {
        this.service.listarOperacoesVazio(armador, agendTipoId).then(response => {
            if (response.data)
                this.operacoes[index] = response.data;
             
        }).catch( erro => {
            console.log(erro)
        });
    };

    carregarTiposCntr = (oper, index) => {
        this.tiposCntr[index] = [];
        this.shipments[index] = [];
        this.tiposCntrVisible[index] = oper ? true : false;
        if (this.armadorSelecionado[index] && oper) this.dadosBoxTiposCntr(this.armadorSelecionado[index].label, oper.value, index);
    };

    dadosBoxTiposCntr = (armador, oper, index) => {
        this.service.listarTiposCntrVazio(armador, oper).then(response => {
            if (response.data)
                this.tiposCntr[index] = response.data;
           
        }).catch( erro => {
            console.log(erro)
        });
    };

    carregarShipment = (tipoCntr, index) => {
        this.shipments[index] = [];
        this.shipmentsVisible[index] = tipoCntr ? true : false;
        if (this.armadorSelecionado[index] && this.operacaoSelecionado[index] && tipoCntr) 
            this.dadosBoxShipment(this.armadorSelecionado[index].label, this.operacaoSelecionado[index].value, tipoCntr.label, index);
    };

    dadosBoxShipment = (armador, oper, tipoCntr, index) => {
        this.shipmentsVisible[index] = false
        this.service.listarShipmentsVazio(armador, oper, tipoCntr).then(response => {
            if (response.data.length > 0) {
                this.shipments[index] = response.data;
                this.shipmentsVisible[index] = true
            }
        }).catch( erro => {
            console.log(erro)
        });
    };

    carregarContainer = (tipoCntr, agendId, index) => {
        this.container[index] = [];
        if (this.armadorSelecionado[index] && this.operacaoSelecionado[index] && tipoCntr) 
            this.dadosCampoContainer(this.armadorSelecionado[index].value, this.operacaoSelecionado[index].value, tipoCntr.label, agendId, index);
    };

    dadosCampoContainer = (armador, oper, tipoCntr, agendId, index) => {
        this.service.buscarQtdDisponivelVazio(armador, oper, tipoCntr, agendId).then(response => {
            if (response)
                this.container[index] = response.data;
        }).catch( erro => {
            console.log(erro)
        });
    };

    // carregarContainersDocumentos = (di) => {
    //     this.containers = false;
    //     if (di)
    //         this.service.listarContainersRetirada(di.value).then(response => {
    //             this.containers = response.data;
    //         }).catch( erro => {
    //             console.log(erro)
    //         });
    // };
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers/stores/RetiradaStore.js